module.exports = __webpack_public_path__ + "img/A17a_20180249-006.984c1793.jpg";